import type { ReadonlyNonEmptyArray, ReadonlyRecord } from '../../utils'

export enum DocumentationType {
    CYBUS_DOCS = 'CYBUS_DOCS',
    LICENSE_OFFLINE_ACTIVATION = 'LICENSE_OFFLINE_ACTIVATION',
    LICENSING = 'LICENSING',
    MQTT_PREFIX = 'MQTT_PREFIX',
    RULE_ENGINE_PARSE_RULE = 'RULE_ENGINE_PARSE_RULE',
    SERVICES = 'SERVICES',
    SERVICES_COMMISSIONING_FILE = 'SERVICES_COMMISSIONING_FILE',
    UI_ACCESS_PERMISSIONS = 'UI_ACCESS_PERMISSIONS',
}

export enum FileExtensionType {
    CERTIFICATE = 'CERTIFICATE',
    LICENSE = 'LICENSE',
    SERVICE_COMMISSIONING = 'SERVICE_COMMISSIONING',
}

export interface ConfigurationService {
    getResourcesPaginationSizes(): readonly [short: number, medium: number, large: number, max: number]
    getResourcesSearchThreshold(): number
    /**
     * How often then client registry should be updated in milliseconds
     */
    getClientRegistryRefreshRate(): number
    getApplicationMetadata(): ReadonlyRecord<string, string>
    getDocumentationURL(type: DocumentationType): URL
    getWorkbenchURL(): URL

    getSupportedFileExtensions(type: FileExtensionType): ReadonlyNonEmptyArray<string>
    getServiceCommissioningFileDownloadMimeType(): string

    getSalesEmail(): string
    getSupportEmail(): string

    getInfoPageRefreshRate(): number

    /**
     * A sensible timeout for when the user may interact with the application too quickly
     * causing too many requests to be sent to services
     */
    getInteractionThrottle(): number

    /**
     * How long should the end user be warned that they will be logged out
     */
    getLogoutWarningPeriod(): number

    /**
     * Whether the internal component Storybook page is reachable
     */
    isStorybookEnabled(): boolean
}
